import { View } from 'react-native';

import { Body } from './Body';
import { Display } from './Display';
import { Eyebrow } from './Eyebrow';
import { Mono } from './Mono';
import { Tick } from './Tick';

const SEALED_ITEMS = [
  { label: 'Windows closed', meta: '09:33 JM' },
  { label: 'Front hatch closed', meta: '09:35 AR' },
  { label: 'Bilge pump on auto', meta: '09:38 JM' },
  { label: 'Fresh water pump off', meta: '09:40 AR' },
];

export function SealedCard() {
  return (
    <View
      className="w-[360px] flex-none rounded-[22px] bg-background px-6 py-7"
      style={{ boxShadow: '0 30px 60px -24px rgba(0,0,0,0.6)' }}
    >
      <View
        className="absolute right-[18px] top-[18px] rounded-[7px] border-2 border-signal px-2.5 py-1"
        style={{ transform: [{ rotate: '7deg' }] }}
      >
        <Eyebrow className="text-[11px] tracking-[0.18em] text-signal">Sealed</Eyebrow>
      </View>

      <Eyebrow className="mb-2 text-[10px] tracking-[0.14em] text-faint">
        Run #0428 · Mar 14
      </Eyebrow>
      <Display className="mb-5 text-[22px] tracking-[-0.01em] text-foreground">
        Leaving the boat
      </Display>

      <View>
        {SEALED_ITEMS.map((item) => (
          <View
            key={item.label}
            className="flex-row items-center gap-3 border-t border-border py-3"
          >
            <Tick checked size="sm" />
            <Body className="flex-1 text-sm text-foreground">{item.label}</Body>
            <Mono className="text-[11px] text-faint">{item.meta}</Mono>
          </View>
        ))}
      </View>

      <View className="mt-4 flex-row items-center justify-between border-t border-border pt-4">
        <Eyebrow className="text-[10.5px] tracking-[0.1em] text-muted">
          Locked · no edits after seal
        </Eyebrow>
        <Mono className="text-[11px] text-foreground">12 / 12</Mono>
      </View>
    </View>
  );
}
